import { WarningIcon, Modal, Status } from "@mwi/ui";

const LimitedExperienceModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="flex flex-col flex-grow"
    >
      <Status
        danger
        title="Limited experience" // eslint-disable-next-line max-len
        description="Our dashboard service is not optimized for mobile or vertical tablet experience yet. Try it out on desktop!"
        primaryLinkText="Continue"
        onClick={onClose}
        graphic={<WarningIcon />}
      />
    </Modal>
  );
};

export default LimitedExperienceModal;
